import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { version as appVersion } from '../../package.json';
import footerLogoLight from './assets/logo.svg';
import footerLogoDark from './assets/logo-gold.svg';

class LayoutFooter extends Component {
  constructor(props) {
    super(props);
    this.handleThemeChanged = this.handleThemeChanged.bind(this);
  }

  componentDidMount() {
    window.addEventListener('themeChanged', this.handleThemeChanged);
  }

  componentWillUnmount() {
    window.removeEventListener('themeChanged', this.handleThemeChanged);
  }

  handleThemeChanged() {
    this.forceUpdate();
  }

  render() {
  var isDark = document.documentElement.classList.contains('tw-dark');
  return (
    <footer className="mobile-tab-padding" style={{ backgroundColor: isDark ? '#0a0a0a' : '#fafafa', borderTop: isDark ? '1px solid #1a1a1a' : '1px solid #e8e8e8' }}>
      <div className="tw-max-w-6xl tw-mx-auto tw-px-4 tw-pt-12 tw-pb-8">
        <div className="tw-grid tw-grid-cols-2 md:tw-grid-cols-4 tw-gap-8 tw-mb-10">
          {/* Brand column */}
          <div className="tw-col-span-2 md:tw-col-span-1">
            <div className="tw-flex tw-items-center tw-gap-2 tw-mb-3">
              <img src={isDark ? footerLogoDark : footerLogoLight} alt="Primal Marketplace" className="tw-h-10 tw-w-auto" />
              <span style={{ fontFamily: "'Nunito', sans-serif", fontSize: '18px', fontWeight: 800, letterSpacing: '-0.3px', color: isDark ? '#c9a84c' : '#1a1a1a' }}>
                PrimalMarket
              </span>
            </div>
            <p className="tw-text-sm tw-leading-relaxed tw-mb-4" style={{ color: isDark ? '#888' : '#888' }}>
              The trusted marketplace for Primal TCG collectors.
            </p>
            <div className="tw-flex tw-items-center tw-gap-3">
              <a
                href="https://twitter.com/primaltcg"
                target="_blank"
                rel="noopener noreferrer"
                className="tw-w-8 tw-h-8 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-text-sm tw-transition-colors tw-no-underline"
                style={{ backgroundColor: isDark ? '#1a1a1a' : '#f0f0f0', color: isDark ? '#888' : '#888' }}
                aria-label="Twitter"
                onMouseEnter={function(e) { e.currentTarget.style.color = '#c9a84c'; }}
                onMouseLeave={function(e) { e.currentTarget.style.color = '#888'; }}
              >
                <i className="fa fa-twitter" />
              </a>
              <a
                href="https://discord.com/invite/pxTRcC32nZ"
                target="_blank"
                rel="noopener noreferrer"
                className="tw-w-8 tw-h-8 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-text-sm tw-transition-colors tw-no-underline"
                style={{ backgroundColor: isDark ? '#1a1a1a' : '#f0f0f0', color: isDark ? '#888' : '#888' }}
                aria-label="Discord"
                onMouseEnter={function(e) { e.currentTarget.style.color = '#c9a84c'; }}
                onMouseLeave={function(e) { e.currentTarget.style.color = '#888'; }}
              >
                <svg width="14" height="14" viewBox="0 0 71 55" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M60.1 4.9A58.5 58.5 0 0045.4.2a.2.2 0 00-.2.1 40.8 40.8 0 00-1.8 3.7 54 54 0 00-16.2 0A37.4 37.4 0 0025.4.3a.2.2 0 00-.2-.1A58.4 58.4 0 0010.5 4.9a.2.2 0 00-.1.1C1.5 18.7-.9 32.2.3 45.5v.2a58.9 58.9 0 0017.7 9a.2.2 0 00.3-.1 42.1 42.1 0 003.6-5.9.2.2 0 00-.1-.3 38.8 38.8 0 01-5.5-2.7.2.2 0 01 0-.4l1.1-.9a.2.2 0 01.2 0 42 42 0 0035.6 0 .2.2 0 01.2 0l1.1.9a.2.2 0 010 .4 36.4 36.4 0 01-5.5 2.7.2.2 0 00-.1.3 47.3 47.3 0 003.6 5.9.2.2 0 00.3.1A58.7 58.7 0 0070.5 45.7v-.2c1.4-15-2.3-28.1-9.8-39.7a.2.2 0 00-.1 0zM23.7 37.3c-3.4 0-6.3-3.2-6.3-7s2.8-7 6.3-7 6.4 3.1 6.3 7-2.8 7-6.3 7zm23.2 0c-3.4 0-6.3-3.2-6.3-7s2.8-7 6.3-7 6.4 3.1 6.3 7-2.8 7-6.3 7z"/></svg>
              </a>
              <a
                href="https://instagram.com/primaltcg"
                target="_blank"
                rel="noopener noreferrer"
                className="tw-w-8 tw-h-8 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-text-sm tw-transition-colors tw-no-underline"
                style={{ backgroundColor: isDark ? '#1a1a1a' : '#f0f0f0', color: isDark ? '#888' : '#888' }}
                aria-label="Instagram"
                onMouseEnter={function(e) { e.currentTarget.style.color = '#c9a84c'; }}
                onMouseLeave={function(e) { e.currentTarget.style.color = '#888'; }}
              >
                <i className="fa fa-instagram" />
              </a>
            </div>
          </div>

          {/* Marketplace column */}
          <div>
            <h4
              className="tw-text-xs tw-font-bold tw-uppercase tw-tracking-wider tw-mb-3"
              style={{ color: isDark ? '#555' : '#999' }}
            >
              Marketplace
            </h4>
            <ul className="tw-list-none tw-p-0 tw-m-0" style={{ lineHeight: '2.2' }}>
              <li>
                <Link to="/browse" className="tw-text-sm tw-no-underline tw-transition-colors" style={{ color: isDark ? '#aaa' : '#666' }}
                  onMouseEnter={function(e) { e.currentTarget.style.color = '#c9a84c'; }}
                  onMouseLeave={function(e) { e.currentTarget.style.color = isDark ? '#aaa' : '#666'; }}
                >Browse Cards</Link>
              </li>
              <li>
                <Link to="/sell" className="tw-text-sm tw-no-underline tw-transition-colors" style={{ color: isDark ? '#aaa' : '#666' }}
                  onMouseEnter={function(e) { e.currentTarget.style.color = '#c9a84c'; }}
                  onMouseLeave={function(e) { e.currentTarget.style.color = isDark ? '#aaa' : '#666'; }}
                >Sell Cards</Link>
              </li>
              <li>
                <Link to="/shipping" className="tw-text-sm tw-no-underline tw-transition-colors" style={{ color: isDark ? '#aaa' : '#666' }}
                  onMouseEnter={function(e) { e.currentTarget.style.color = '#c9a84c'; }}
                  onMouseLeave={function(e) { e.currentTarget.style.color = isDark ? '#aaa' : '#666'; }}
                >Shipping Guide</Link>
              </li>
            </ul>
          </div>

          {/* Help column */}
          <div>
            <h4
              className="tw-text-xs tw-font-bold tw-uppercase tw-tracking-wider tw-mb-3"
              style={{ color: isDark ? '#555' : '#999' }}
            >
              Help
            </h4>
            <ul className="tw-list-none tw-p-0 tw-m-0" style={{ lineHeight: '2.2' }}>
              <li>
                <Link to="/how-to-sell" className="tw-text-sm tw-no-underline tw-transition-colors" style={{ color: isDark ? '#aaa' : '#666' }}
                  onMouseEnter={function(e) { e.currentTarget.style.color = '#c9a84c'; }}
                  onMouseLeave={function(e) { e.currentTarget.style.color = isDark ? '#aaa' : '#666'; }}
                >How to Sell</Link>
              </li>
              <li>
                <Link to="/how-to-buy" className="tw-text-sm tw-no-underline tw-transition-colors" style={{ color: isDark ? '#aaa' : '#666' }}
                  onMouseEnter={function(e) { e.currentTarget.style.color = '#c9a84c'; }}
                  onMouseLeave={function(e) { e.currentTarget.style.color = isDark ? '#aaa' : '#666'; }}
                >How to Buy</Link>
              </li>
              <li>
                <Link to="/cart-optimizer" className="tw-text-sm tw-no-underline tw-transition-colors" style={{ color: isDark ? '#aaa' : '#666' }}
                  onMouseEnter={function(e) { e.currentTarget.style.color = '#c9a84c'; }}
                  onMouseLeave={function(e) { e.currentTarget.style.color = isDark ? '#aaa' : '#666'; }}
                >Cart Optimizer</Link>
              </li>
              <li>
                <Link to="/payouts" className="tw-text-sm tw-no-underline tw-transition-colors" style={{ color: isDark ? '#aaa' : '#666' }}
                  onMouseEnter={function(e) { e.currentTarget.style.color = '#c9a84c'; }}
                  onMouseLeave={function(e) { e.currentTarget.style.color = isDark ? '#aaa' : '#666'; }}
                >Receiving Payouts</Link>
              </li>
              <li>
                <Link to="/faq" className="tw-text-sm tw-no-underline tw-transition-colors" style={{ color: isDark ? '#aaa' : '#666' }}
                  onMouseEnter={function(e) { e.currentTarget.style.color = '#c9a84c'; }}
                  onMouseLeave={function(e) { e.currentTarget.style.color = isDark ? '#aaa' : '#666'; }}
                >FAQ</Link>
              </li>
            </ul>
          </div>

          {/* Company column */}
          <div>
            <h4
              className="tw-text-xs tw-font-bold tw-uppercase tw-tracking-wider tw-mb-3"
              style={{ color: isDark ? '#555' : '#999' }}
            >
              Company
            </h4>
            <ul className="tw-list-none tw-p-0 tw-m-0" style={{ lineHeight: '2.2' }}>
              <li>
                <Link to="/contact" className="tw-text-sm tw-no-underline tw-transition-colors" style={{ color: isDark ? '#aaa' : '#666' }}
                  onMouseEnter={function(e) { e.currentTarget.style.color = '#c9a84c'; }}
                  onMouseLeave={function(e) { e.currentTarget.style.color = isDark ? '#aaa' : '#666'; }}
                >Contact Us</Link>
              </li>
              <li>
                <Link to="/more" className="tw-text-sm tw-no-underline tw-transition-colors" style={{ color: isDark ? '#aaa' : '#666' }}
                  onMouseEnter={function(e) { e.currentTarget.style.color = '#c9a84c'; }}
                  onMouseLeave={function(e) { e.currentTarget.style.color = isDark ? '#aaa' : '#666'; }}
                >How It Works</Link>
              </li>
              <li>
                <Link to="/privacy" className="tw-text-sm tw-no-underline tw-transition-colors" style={{ color: isDark ? '#aaa' : '#666' }}
                  onMouseEnter={function(e) { e.currentTarget.style.color = '#c9a84c'; }}
                  onMouseLeave={function(e) { e.currentTarget.style.color = isDark ? '#aaa' : '#666'; }}
                >Privacy Policy</Link>
              </li>
              <li>
                <Link to="/terms" className="tw-text-sm tw-no-underline tw-transition-colors" style={{ color: isDark ? '#aaa' : '#666' }}
                  onMouseEnter={function(e) { e.currentTarget.style.color = '#c9a84c'; }}
                  onMouseLeave={function(e) { e.currentTarget.style.color = isDark ? '#aaa' : '#666'; }}
                >Terms of Service</Link>
              </li>
              <li>
                <button
                  onClick={function () { window.dispatchEvent(new CustomEvent('showCookieConsent')); }}
                  className="tw-text-sm tw-bg-transparent tw-border-0 tw-p-0 tw-cursor-pointer tw-font-inherit tw-transition-colors"
                  style={{ color: isDark ? '#aaa' : '#666' }}
                  onMouseEnter={function(e) { e.currentTarget.style.color = '#c9a84c'; }}
                  onMouseLeave={function(e) { e.currentTarget.style.color = isDark ? '#aaa' : '#666'; }}
                >Cookie Preferences</button>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div
          className="tw-flex tw-flex-col sm:tw-flex-row tw-items-center tw-justify-between tw-gap-3 tw-pt-6"
          style={{ borderTop: isDark ? '1px solid #1a1a1a' : '1px solid #e8e8e8' }}
        >
          <p className="tw-text-xs tw-mb-0" style={{ color: isDark ? '#777' : '#bbb' }}>
            &copy; {new Date().getFullYear()} Primal Market. All rights reserved. <span style={{ opacity: 0.6 }}>v{appVersion}</span>
          </p>
          <p className="tw-text-xs tw-mb-0" style={{ color: isDark ? '#777' : '#bbb' }}>
            Made with <i className="fa fa-heart tw-mx-0.5" style={{ color: '#c9a84c', fontSize: '10px' }} /> for the Primal TCG community
          </p>
        </div>
      </div>
    </footer>
  );
  }
}

export default LayoutFooter;
